// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".has-whitespace-nowrap[data-v-6940bc9b] {\n  white-space: nowrap;\n}\n.error-input[data-v-6940bc9b] {\n  border-color: #a94442;\n}\n.error-input.is-active[data-v-6940bc9b] {\n  box-shadow: 0 0 0 var(--ms-ring-width, 3px) rgba(169, 68, 66, 0.4);\n}\n.error-message[data-v-6940bc9b] {\n  margin: 0 0 1% 0;\n  color: #a94442;\n  font-size: 12px;\n}\n.error-label[data-v-6940bc9b] {\n  color: #a94442;\n}", ""]);
// Exports
module.exports = exports;
